import * as React from 'react';
import styled, { css } from 'styled-components/macro';
import { useState } from 'react';

const Switch = styled.div<{ disabled?: boolean }>`
  display: flex;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.neutral['40']};
  background-color: ${({ theme }) => theme.colors.secondary['5']};
  padding: 2px;
  gap: 2px;
  height: 34px;
  align-items: center;
  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}
`;

const ToggleOption = styled.div<{ selected: boolean }>`
  padding: 8px 12px;
  border-radius: 3px;
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
  text-align: center;
  color: ${({ selected, theme }) =>
    selected ? theme.colors.white['100'] : theme.colors.neutral['60']};
  background-color: ${({ selected, theme }) =>
    selected ? theme.colors.primary['100'] : 'transparent'};
  line-height: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${({ selected, theme }) =>
      selected ? theme.colors.primary['100'] : theme.colors.black['5']};
  }
`;

export type Value = {
  text: string;
  value: string;
  width?: string;
};
type Props = {
  defaultValue: string;
  onChange: (value: string) => void;
  values: Value[];
  skipConfirmation?: boolean;
  className?: string;
  disabled?: boolean;
};

export const ArchiveButtonSwitch = (props: Props) => {
  const {
    defaultValue,
    values,
    onChange,
    className,
    skipConfirmation = true,
    disabled,
  } = props;

  const [value, setValue] = useState(defaultValue);

  return (
    <Switch className={className} disabled={disabled}>
      {values.map(btn => (
        <ToggleOption
          key={btn.value}
          selected={btn.value === value}
          onClick={() => {
            onChange(btn.value);
            if (skipConfirmation) setValue(btn.value);
          }}
        >
          {btn.text}
        </ToggleOption>
      ))}
    </Switch>
  );
};
